<template>
  <div :style="{width: width + 'px', height: width + 'px'}" class="lds-dual-ring">
    <div :style="{borderColor: color + ' transparent'}" class="lds-dual-ring-pseudo"/>
  </div>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 30 },
    color: { type: String, default: "rgb(0, 139, 200)" }
  }
};
</script>

<style lang="scss">
.lds-dual-ring {
  display: inline-block;
}
.lds-dual-ring-pseudo {
  content: " ";
  display: block;
  width: 100%;
  height: 100%;
  margin: 1px;
  border-radius: 50%;
  border: 3px solid #fff;
  animation: lds-dual-ring 0.6s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
